import { rem } from 'polished';
import { BodyText } from '@unmind/design-system';
import { Message } from 'Assistant/Chatbot/types';
import styled from 'styled-components';
import { IconProps, Microphone, NovaMessageTail } from 'icons';

export const MessageCard = styled.div<{
  sender: Message['role'];
  hasOptions?: boolean;
}>`
  position: relative;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: ${rem(16)};
`;

export const UserMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const UserMessageBubble = styled.div`
  margin-left: auto;
  margin-right: 12px;
  max-width: 80%;
  white-space: pre-wrap;
  padding: 0 12px;
  border-radius: 12px;
  background-color: ${({ theme }) =>
    theme.colors.chatbot.messages.user.background};
  overflow: hidden;
`;

export const TranscriptionIconContainer = styled.div`
  justify-content: flex-end;
  align-items: center;
  display: flex;
  padding-right: 8px;
`;

export const TranscriptionIcon = styled(Microphone).attrs(({ theme }) => ({
  width: theme.typography.fontSizes.fontSize16,
  height: theme.typography.fontSizes.fontSize16,
  primaryColor: theme.colors.text.secondary,
}))``;

export const UserMessage = styled(BodyText).attrs(({ theme, italic }) => ({
  color: italic ? theme.colors.text.secondary : theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize16],
}))``;

type UserMessageTailProps = IconProps & {
  $isVoice?: boolean;
};

export const UserMessageTail = styled(NovaMessageTail).attrs(({ theme }) => ({
  primaryColor: theme.colors.chatbot.messages.user.background,
  width: theme.typography.fontSizes.fontSize24,
  height: theme.typography.fontSizes.fontSize24,
}))<UserMessageTailProps>`
  position: absolute;
  bottom: ${({ $isVoice }) => ($isVoice ? '38px' : '12px')};
  right: 22px;
`;

export const MessageText = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.regular,
  color: theme.colors.text.primary,
}))`
  word-wrap: anywhere;

  & :first-child {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

export const MessageTextWrapper = styled.div<{
  isLoading?: boolean;
  hasOptions?: boolean;
}>`
  position: relative;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  gap: 16px;
  width: 100%;
  flex-direction: ${({ hasOptions }) => (hasOptions ? 'row' : 'column')};

  & a {
    text-decoration: underline;
    text-underline-offset: 0.25em;
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export const LoadingWrapper = styled.div`
  align-self: center;
`;

export const ContentCardsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
`;

export const ContentCardWrapper = styled.div`
  max-width: 250px;
  a {
    text-decoration: none;
  }
`;
export const CategoryCardWrapper = styled.div`
  a {
    text-decoration: none;
  }
`;

export const CategoryCardsRow = ContentCardsRow;
